import React from 'react';

/** The bettercollected mark: the wordmark's "b", in ink (DESIGN.md "Logo"). */
export default function BetterCollectedSmallLogo(props: React.SVGAttributes<SVGSVGElement>) {
    return (
        <svg width="21" height="21" viewBox="-36 -720 730 730" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" {...props}>
            <path fill="#101828" d="M358 10Q285 10 238.5 -24.5Q192 -59 181 -120L190 -121V0H67V-720H193V-395L184 -397Q197 -454 245.5 -487Q294 -520 366 -520Q434 -520 484.5 -487.5Q535 -455 563 -396Q591 -337 591 -257Q591 -176 562 -116Q533 -56 481 -23Q429 10 358 10ZM326 -94Q387 -94 423 -136.5Q459 -179 459 -256Q459 -333 422.5 -375Q386 -417 325 -417Q265 -417 228 -374.5Q191 -332 191 -255Q191 -178 228 -136Q265 -94 326 -94Z" />
        </svg>
    );
}
